<div class="fs-2 with-close" mat-dialog-title>
    Ajouter un projet
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <form (ngSubmit)="onYesClick()" [formGroup]="favoriteForm">
        <mat-form-field>
            <mat-label>Liste</mat-label>
            <mat-select disableOptionCentering formControlName="listFavorite" (selectionChange)="loadFavorites()">
                <mat-option *ngFor="let l of listFavorites" value="{{l.id}}">{{l.title}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Favori</mat-label>
            <mat-select disableOptionCentering formControlName="favorite" [disabled]="favorites.length == 0">
                <mat-option *ngFor="let l of favorites" value="{{l.id}}">{{l.title}}</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()"  class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        Valider
    </button>
</div>

